import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function InquirySuccess() {
  return (
    <main className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="inquiry-success-page">
      <div className="w-20 h-20 mx-auto rounded-full bg-primary/10 text-primary flex items-center justify-center">
        <CheckCircle2 className="w-10 h-10" />
      </div>
      <h1 className="font-display text-4xl font-bold mt-6">Inquiry received!</h1>
      <p className="text-muted-foreground mt-3 leading-relaxed">
        Thank you for choosing nivilabs. Our scientific procurement team will reach out within
        <span className="text-foreground font-semibold"> 24 hours</span> with a tailored quotation.
        A confirmation has been sent to our team — and to you, if your address is verified.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild className="bg-primary hover:bg-primary/90"><Link to="/products">Continue browsing</Link></Button>
        <Button asChild variant="outline"><Link to="/account/inquiries">Track my inquiries</Link></Button>
      </div>
    </main>
  );
}
